<script setup>
import { defineProps } from "vue";
import btnMenuAsideOpenClose from "@/components/app/buttons/btnMenuAsideOpenClose.vue";
import btnDropdownLogout from "@/components/app/buttons/btnDropdownLogout.vue";
import { useAsideFunctions } from "@/composables/useAsideFunctions";
import { RouterLink } from "vue-router";

// eslint-disable-next-line no-unused-vars
const { navMenuItems, isMenuCollapsed, toggleMenu, selectMenuItem } =
  useAsideFunctions();
const props = defineProps({
  nomeUsuario: {
    type: String,
    default: "",
  },
  perfilUsuario: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    default: "PAINEL DE CONTROLE",
  },
});
</script>

<template>
  <nav
    class="w-full justify-between py-2 shadow-dark-mild bg-gradient-blue lg:py-4"
  >
    <div class="flex w-full flex-wrap items-center justify-between px-3">
      <div class="ms-2">
        <div class="flex justify-between items-center space-x-4">
          <btnMenuAsideOpenClose
            v-if="props.nomeUsuario"
            :actionOnClick="toggleMenu"
            class="md:hidden"
          />
          <RouterLink to="/" class="text-xl text-white text-uppercase font-bold"
            >{{ props.title }}
          </RouterLink>
        </div>
      </div>
      <div v-if="props.nomeUsuario" class="ms-2 hidden md:block">
        <div class="flex justify-between items-center space-x-4">
          <div class="">
            <p class="text-white text-sm font-bold">
              Bem vindo(a)
              <span class="uppercase">{{ props.nomeUsuario }}</span>
            </p>
            <p class="text-white text-sm">
              PERFIL:
              <span class="font-red text-sm uppercase">{{
                props.perfilUsuario
              }}</span>
            </p>
          </div>
          <btnDropdownLogout />
        </div>
      </div>
    </div>
  </nav>
</template>
